import numeral from "numeral";

numeral.register("locale", "brasil", {
  delimiters: {
    thousands: ".",
    decimal: ","
  },
  abbreviations: {
    thousand: "mil",
    million: "milhões",
    billion: "b",
    trillion: "t"
  },
  ordinal: function(number) {
    return "º";
  },
  currency: {
    symbol: "R$"
  }
});

numeral.locale("brasil");

export const formata = {
  methods: {
    formatar_valor(val) {
      let valor = numeral(val);
      let valformat = numeral(valor).value;
      return valor.format(" 0.00");
    },
    formatar_moeda(val) {
      let valor = numeral(val);
      let valformat = numeral(valor).value;
      return valor.format("$ 0.00");
    },
    upperCase: function(valor) {
      return valor.toUpperCase();
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/format.js